module.exports = __webpack_public_path__ + "static/media/1017067.84087cd8.png";